import React, { useState, useCallback } from 'react'
import debounce from "lodash.debounce"
import handleNoOp from "../utils/handleNoOp"

import "../styles/search.scss"
import { useAtom } from 'jotai'
import atoms from '../utils/atoms'

function Search(props) {

    const [, setForm] = useAtom(atoms.form)

    const handleChange = useCallback(debounce((e) => {
        setForm(f => { f.search =  e.target.value })
    }, 400), [setForm])

    return (
        <span className="searchContainer mb-2">
            <form onSubmit={handleNoOp} className="">
                <i className="fas fa-search ml-2"></i>
                <input className="mr-3 w-100 form-control d-inline-block" type="search" name="search" maxLength="300"
                    id="search" placeholder="Search for a course" aria-label="Search for a course"
                    onChange={handleChange}
                    aria-controls="course-results" />
            </form>
        </span>
    )
}

export default Search;